import Vue from 'vue';
import { store } from '../../store/store';

Vue.mixin({
  methods: {
    can(action) {
      const { permissions } = store.state.user;
      if (!permissions || !permissions.permissions) return false;
      return permissions.permissions.includes(action);
    },
    hasRole(action) {
      const { permissions } = store.state.user;
      if (!permissions || !permissions.roles) return false;
      return permissions.roles.includes(action);
    },
  },
});
